import React from 'react';
import { connect } from 'react-redux';
import properties from '../../modules/ajio-util/properties';
import { segmentEventPush } from '../../modules/ga/GTMdatalayer';
// import './error.scss';

class Error503 extends React.Component { 
 
  componentDidMount() {

    segmentEventPush({
        event:'Page Load Error',
        screen_name: 'Error Component',
        error_description: 503
    });    

  }
  render() {
    const { show = false, className = '', mobile = false } = this.props;
    return (
      <div className={`http-error notfound service-unavailable ${className}`}>
        <div className="logo-image">
          <div className="ic-logo" />
        </div>

        <div className="ta-center">
          <img
            src={`${properties.getProperty('imageBaseUrl')}/static/img/HangerPage.jpg`}
            width="264"
            height="204"
            alt='Hang in there image'
          />
        </div>
        <div className="ta-center right-back">We will be right back!</div>

        <div className="ta-center error-text">
          Whoops. That just happened. We’re fixing this & will be with you soon!
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { httpError = {} } = state;
  const { name } = ownProps;
  let show = false;
  if (httpError[name] && httpError[name].errorCode == 503) {
    show = true;
  }
  return {
    show
  };
};

export default connect(mapStateToProps)(Error503);
